import { useState } from 'react';
import useFetch from 'lib/hooks/useFetch';

import Editor from './Editor';
import List from './List';

import { Icon } from '@frontendmentorio/design-system-v2';

export default function CodeEditor({ isAuthor, solution }) {
  const [selectedFile, setSelectedFile] = useState();
  const [isEditorVisible, setIsEditorVisible] = useState();

  const { data: { data: contents } = {}, isLoading } = useFetch(
    `/api/v3/services/repo?url=${solution.repoURL}`
  );

  return (
    <div className="border border-neutral-200 font-mono overflow-hidden relative rounded-lg w-full">
      <div className="grid h-[40rem] overflow-auto tablet:flex">
        {isLoading && (
          <div className="flex-center flex-col gap-4 h-full p-5 w-full">
            <span className="text-neutral-500 text-sm">Loading...</span>
          </div>
        )}

        {!isLoading && contents && (
          <>
            <List
              className="bg-[hsl(0,0%,96%)] col-start-1 row-start-1 overflow-auto p-2 shrink-0 tablet:w-[20rem]"
              items={contents}
              selectedFile={selectedFile}
              setIsEditorVisible={setIsEditorVisible}
              setSelectedFile={setSelectedFile}
              solution={solution}
            />

            <Editor
              isEditorVisible={isEditorVisible}
              selectedFile={selectedFile}
              setIsEditorVisible={setIsEditorVisible}
              solution={solution}
            />
          </>
        )}

        {!isLoading && !contents && (
          <div className="flex-center flex-col gap-4 p-5 text-center text-neutral-500 text-sm w-full">
            <Icon
              className="text-xl"
              name="triangle-exclamation"
              style="light"
            />

            <span>Couldn’t fetch repository</span>

            {isAuthor && (
              <span className="max-w-prose">
                We currently only support GitHub repositories. <br /> If you are
                using GitHub, please check that your repo URL is correct.
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
